













import { Component, Vue } from 'vue-property-decorator';

import SimpleDialog from '@/components/common/SimpleDialog.vue';
import { ErrorHandleStore } from '@/store/ErrorHandleStore';
import { LoadingStore } from '@/store/LoadingStore';

@Component({
  components: {
    SimpleDialog,
  },
})
export default class ExceptionDialog extends Vue {
  errorHandleStore = ErrorHandleStore();
  loadingStore = LoadingStore();

  closeDialog() {
    this.loadingStore.$reset();
    this.errorHandleStore.isExistException = false;
  }

  beforeDestroy() {
    this.loadingStore.$reset();
    this.errorHandleStore.$reset();
  }
}
